import { useRef, useState, useEffect } from "react";
import {
    Box,
    Drawer,
    DrawerContent,
    DrawerCloseButton,
    DrawerHeader,
    DrawerOverlay,
    Show,
    Text,
  } from '@chakra-ui/react';
import { romUrl } from './config/rom';
  
  export const Player = ({ ...props}) => {
    const headerRef = useRef<HTMLDivElement>(null);
    const [showSpinner, setShowSpinner] = useState(false);

    useEffect(() => {
      const timer = setTimeout(() => {
        setShowSpinner(true);
      }, 2000);

      return () => {
        clearTimeout(timer);
        setShowSpinner(false);
      };
    }, [props.isOpen]);
  
    return (
      <Drawer
        isOpen={props.isOpen}
        placement="right"
        onClose={props.onClose}
        size="md"
      >
        <DrawerOverlay />
  
        <DrawerContent backgroundColor="#F5EFEA" className="no-touch-action">
          <DrawerHeader ref={headerRef} borderBottomWidth='0px' padding={2}>
            <Text
              overflow="hidden"
              display="flex"
              textOverflow="ellipsis"
              sx={{
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                alignItems: "center"
              }}
              pr="42px"
              minHeight="32px"
              fontWeight="bold"
              fontSize={14}>
              {props.title}
            </Text>
            <Show below="xl">
              <DrawerCloseButton fontWeight="bold" size="md" />
            </Show>
          </DrawerHeader>
          {showSpinner && (
            <Box 
              className="loadingio-spinner-bars-nq4q5u6dq7r" 
              position="absolute" top="35%" left="50%" 
              transform="translate(-50%, -50%)" >
              <div className="ldio-x2uulkbinbj">
                <div></div><div></div><div></div><div></div>
              </div>
            </Box>
          )}
          <Box
            as="iframe"
            id="wasm-player"
            width="100%"
            height="100%"
            className="no-touch-action"
            src={`${process.env.PUBLIC_URL}/player/player.html?${new URLSearchParams({
              'rom-url': romUrl(props.selected),
              'product-code': props.selected,
            }).toString()}`}
          />
        </DrawerContent>
      </Drawer>
    );
  };
